import { render, staticRenderFns } from "./Final-Landing.vue?vue&type=template&id=61461118"
import script from "./Final-Landing.vue?vue&type=script&lang=js"
export * from "./Final-Landing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports